import React from 'react';
import PlayerTable from '../common/PlayerTable';

const COLS = [
  { key: 'rank', label: '#', width: 'w-8' },
  { key: 'player', label: 'Player' },
  { key: 'team', label: 'Team', muted: true },
  {
    key: 'minutes',
    label: 'Min',
    align: 'right',
    width: 'w-12',
    bold: true,
    render: (r) => (r.minutes != null ? r.minutes.toLocaleString() : '—'),
  },
  { key: 'appearances', label: 'Apps', align: 'right', width: 'w-10' },
];

export default function Minutes({ minutes = [], ...rest }) {
  return (
    <PlayerTable
      {...rest}
      subtitle="Minutes"
      rows={minutes}
      columns={COLS}
      emptyMessage="No minutes data for this competition."
    />
  );
}
